import React,{useContext} from 'react'
import PrefixContext from "../../../../context/PrefixContext.js";

function Profile(props) {

    const PrefixContextData = useContext(PrefixContext);
    var personImg;
    if(props.image !== undefined)
    {
        personImg = PrefixContextData.cdnPrefixUrl+'uploaded/'+props.image;
    }
    else{
        personImg = PrefixContextData.cdnPrefixUrl+'avtaar_A-JQZIHAe.png';
    }

    return (
        <>
            <div className="image-container">
                <img className="bg-prime" src={personImg} alt="" />
            </div>
        </>
    )
}

export default Profile
